"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.messageBox = void 0;
const chalk_1 = __importDefault(require("chalk"));
const messageBoxString = (title, color, message) => {
    let result = '';
    result += chalk_1.default.bold[color](`┏━ [${title}]\n`);
    if (typeof message === 'string') {
        message.split('\n').forEach((line) => {
            result += `${chalk_1.default.bold[color]('┃ ') + line}\n`;
        });
    }
    else {
        message.forEach((line) => {
            result += `${chalk_1.default.bold[color]('┃ ') + line}\n`;
        });
    }
    result += chalk_1.default.bold[color]('┗━');
    return result;
};
const messageBox = (title, color, message) => {
    console.log(messageBoxString(title, color, message));
};
exports.messageBox = messageBox;
//# sourceMappingURL=message-box.js.map